// extracted by mini-css-extract-plugin
export var checkbox = "_7k-0";
export var circle = "_7k-3";
export var horizontalContainer = "_7k-7";
export var sm = "_7k-5";
export var switch0 = "_7k-2";
export var switchDisabled = "_7k-8";
export var switchEnabled = "_7k-1";
export var textSwitchContainer = "_7k-9";
export var textSwitchOption = "_7k-a";
export var textSwitchOptionSelected = "_7k-b";
export var verticalContainer = "_7k-6";
export var xs = "_7k-4";